/**
 * src/components/shared/MediaImage.tsx
 *
 * CMS'ten yuklenen gorseller icin `next/image` sarmalayicisi.
 *
 * 🔴 NEDEN VAR: `next start`, yerel gorsel optimizasyonu icin `public/`
 * klasorunu ACILISTA tariyor. Sunucu ayaga kalktiktan SONRA yuklenen bir dosya
 * bu listede olmadigi icin `/_next/image` istegi **400 — "The requested
 * resource isn't a valid image"** donuyor ve gorsel kirik gorunuyor. Ham dosya
 * saglam: Nginx `/uploads/` yolunu diskten dogrudan servis ettigi icin (o
 * `location` blogu zaten kurulu) dosyaya erisildiginde 200 geliyor. Tablo bu
 * yuzden yaniltici: dosya var, servis ediliyor, ama optimize edilemiyor.
 *
 * 2026-08-15'te olculerek kanitlandi: PM2 reload ONCESI ayni URL 400, reload
 * SONRASI 200. Yani her yeni yukleme, biri sunucuyu yeniden baslatana kadar
 * kirik gorunuyordu — CMS'i pratikte kullanilamaz kilan bir kusur.
 *
 * COZUM: `/uploads/` altindaki kaynaklar icin optimizasyon atlanir. Kayip
 * kucuk, cunku bu gorseller yukleme aninda zaten `image-processor` tarafindan
 * en fazla 2400 px'e indirilip WebP'ye cevriliyor — ikinci bir optimizasyon
 * turu kazanc saglamiyor. Statik `public/brand/...` gibi build ile gelen
 * gorseller etkilenmez, onlar optimize edilmeye devam eder.
 */
import Image, { type ImageProps } from 'next/image'

/** CMS yuklemelerinin bulundugu yol oneki. */
const YUKLEME_ONEKI = '/uploads/'

/**
 * Kaynagi CMS yuklemesi olan gorselleri optimizasyonu atlayarak, digerlerini
 * normal `next/image` davranisiyla render eder.
 *
 * @param props `next/image` ile birebir ayni arayuz
 */
export function MediaImage(props: ImageProps) {
  const yuklemeMi = typeof props.src === 'string' && props.src.startsWith(YUKLEME_ONEKI)

  // `unoptimized` prop'u disaridan bilerek verilmisse ona saygi gosterilir.
  return <Image {...props} unoptimized={props.unoptimized ?? yuklemeMi} />
}
